import { FC } from 'react';

import { GridColumns } from '@visx/grid';

import useWerklijnen from '../../hooks/useWerklijnen';
import useMwdTimescale from '../../state/selectors/useMwdTimescale';

/**
 * Grid lines represent different times in the MWD.
 */
const Timeline: FC<{ mini?: boolean }> = ({ mini = false }) => {
  const { mwd } = useWerklijnen();
  const { scale, tickValues10Minutes } = useMwdTimescale(mini ? 'miniMwd' : 'mwd');

  return (
    <>
      {/* 10 minute time line */}
      <GridColumns
        left={0}
        scale={scale}
        tickValues={tickValues10Minutes}
        stroke='var(--tractie-color-border-default)'
        height={mwd.height + 8}
        strokeWidth={0.71}
        shapeRendering='crispEdges'
      />

      {/* Hourly time lines */}
      <GridColumns
        left={0}
        scale={scale}
        stroke='var(--tractie-color-border-emphasis)'
        height={mwd.height + 8}
        numTicks={mwd.hoursInView}
        strokeWidth={0.71}
        shapeRendering='crispEdges'
      />
    </>
  );
};
export default Timeline;
